import { ChangeDetectorRef, Directive, inject } from '@angular/core';
import { Orientation, CommonVariable } from 'src/app/app.constants';
import { MatDialog } from "@angular/material/dialog";
import { GamePlayService } from '../services/game-play.service';
import { GamePlayComponent } from "src/app/components/game-play/game-play.component";
import { AuthService } from '@core/auth.service';
import { combineLatest, interval, map, Subject, takeUntil } from "rxjs";
import { TranslateService } from '@ngx-translate/core';
import { MySnackBarService } from '@core/my-snack-bar.service';



@Directive()
export abstract class GamePlayBaseComponent {

    public changeDetectorRef = inject(ChangeDetectorRef)
    public snackService = inject(MySnackBarService)
    public dialog = inject(MatDialog)
    public gamePlayService = inject(GamePlayService)
    public authService = inject(AuthService);
    public translate = inject(TranslateService);

    constructor(
    ) { }
    protected destroy$ = new Subject<void>();
    preferredCurrency: string = CommonVariable.preferredCurrency;
    currencySymbol: string = CommonVariable.defaultCurrencySymbol;
    translatedToastMsg: any;

    gameOrientation: Orientation;
    inProgress: any;
    spinnerAnimation: boolean;
    progressBar: number;
    timer$: any;
    sub: any;
    selectedLanguage: string = "en";
    public isPlayInProgress = false;
    isButtonDisabled = false;
    proceed = true;



    ngOnInit(): void {
        // ✅ Language handling
        this.authService.selectedlanguage$
            ?.pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (l) => {
                    this.selectedLanguage = l || 'en';
                    this.translate.use(this.selectedLanguage);
                },
                error: () => { }
            });

        // ✅ Constants messages
        this.authService.getConstantsMsg$
            ?.pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (msg: any) => {
                    this.translatedToastMsg = msg?.static_messages_pwa;
                },
                error: () => { }
            });

        // ✅ FIXED: No nested subscription
        combineLatest([
            this.authService.userDetails$,
            this.authService.getCurrencyList$
        ])
            ?.pipe(
                takeUntil(this.destroy$),
                map(([user, currencyData]: any) => {
                    const preferredCurrency =
                        user?.preferred_currency ?? CommonVariable.preferredCurrency;

                    const currencyDetails = currencyData?.details?.find(
                        (x: any) => x?.currency_code === preferredCurrency
                    );

                    return {
                        preferredCurrency,
                        currencySymbol:
                            currencyDetails?.currency_symbol ??
                            CommonVariable.defaultCurrencySymbol
                    };
                })
            )
            .subscribe({
                next: ({ preferredCurrency, currencySymbol }) => {
                    this.preferredCurrency = preferredCurrency;
                    this.currencySymbol = currencySymbol;
                },
                error: () => { }
            });
    }
    playGameBase(game: any) {
        if (this.isPlayInProgress) return;

        this.isPlayInProgress = true;

        this.gamePlayService
            .getUserGameInfo(game)
            .then((data: any) => {
            this.isPlayInProgress = false;

            // ✅ Fix bug (was ===)
            this.progressBar = 100;

            this.sub?.unsubscribe();

            setTimeout(() => {
                this.spinnerAnimation = false;
                this.isButtonDisabled = false;
                this.proceed = false;

                setTimeout(() => {
                this.proceed = true;
                }, 2000);
            }, 300);

            this.openPlayGameDialog(data);
            })
            .catch((err: any) => {
            this.isPlayInProgress = false;
            this.isButtonDisabled = false;

            try {
                this.snackService.openSnackBar(
                err?.message,
                "",
                "Error",
                "Error"
                );
            } catch (e) {
                return e;
            }
            });
    }

    private async openPlayGameDialog(game) {
        this.isButtonDisabled = false;
        const dilog = this.dialog.open(GamePlayComponent, {
        height: "100%",
        width: "100%",
        data: { data: game },
        });
    }

    startSpinner() {
        this.spinnerAnimation = true;
        this.progressBar = 0;
        this.timer$ = interval(20);
        this.sub = this.timer$.subscribe(
            (sec) => {
                this.progressBar = 0 + sec;
                this.changeDetectorRef.detectChanges();
            },
            (err) => {
                return err;
            }
        );
    }


    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();

        // ✅ Stop spinner subscription (VERY IMPORTANT)
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}